import axios from 'axios'
import client from '@js/client'
import resources from '@js/resources'
import { CACHE_SIZES, INPUT_MIN_LENGTHS } from '@js/constants'
import { camelKeyToSnakeKey, snakeKeyToCamelKeyRecursive, } from '@js/str-utils'

const getDefaultState = () => {
  return {
    cache: [],
    canceller: null,
  };
};

const userSuggestions = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
    setCache (state, { input, suggestions }) {
      state.cache = state.cache.filter(elem => elem.input.toLowerCase() !== input.toLowerCase());
      if (state.cache.length >= CACHE_SIZES.USER_SUGGESTION) {
        state.cache.shift();
      }
      state.cache.push({ input: input.toLowerCase(), suggestions: suggestions });
    },
  },
  actions: {
    async fetchSuggestions({ state, commit, rootGetters }, input) {
      if (input.length < INPUT_MIN_LENGTHS.USER_SUGGESTION) {
        return [];
      }

      const tenantDomain = await rootGetters['tenant/getTenantDomain'];
      const payload = await {
        inputData: input,
      };

      if (state.canceller) {
        await state.canceller();
        state.canceller = await null;
      }
      const res = await client.post(
        resources['userSuggestions'](tenantDomain),
        camelKeyToSnakeKey(payload),
        {
          cancelToken: new axios.CancelToken(function executor(c) {
            state.canceller = c;
          }),
        },
      );
      const suggestions = await res.data.results.reduce((result, elem) => {
        delete elem.tenant;
        elem.display = `${elem.user.first_name} ${elem.user.last_name}`;
        result.push(snakeKeyToCamelKeyRecursive(elem));
        return result;
      }, []);

      await commit('setCache', { input, suggestions });
      return suggestions;
    },
  },
};

export default userSuggestions;
